var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"modal"}},[_c('button',{staticClass:"closey iconclose",on:{"click":_vm.onCloseModal}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }